import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import spartaStoreUtility from "global/sparta-store-utility";
import spartaEventsUtility from "global/sparta-events-utility";
import spartaMediaQueryUtility from "global/sparta-mediaquery-utility";
import spartaUILayersUtility from "global/sparta-ui-layers-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Module from "global/sparta-module-utility";
import handlebarsRuntime from "vendor/handlebars-runtime";
import hb from "vendor/handlebars-runtime";
import spartaTemplates from "modules/global/global-nav-module/5.4.0/js/templates";
import "css!modules/global/global-nav-module/5.4.0/css/global-nav-module.scss.css";
export default {


  defaults: {
    "target": ".nav-search",
    $target: $(),
    toggle: ".nav-search-toggle",
    $toggle: $(),
    container: ".header-search",
    menu: ".header-panel-toggle.menu-icon",
    $menu: $()
  },


  required: {
    "data": {
      "component": "module",
      "module": "header",
      "skin": "nav-search"
    }
  },


  settings: {},

  checkConfig: function() {
    var isValid = true;

    if (!spaParams.siteParams.secureHost) {
      isValid = false;
      console.error('Global nav search requires site parameter secureHost to be defined!');
    }

    return isValid;
  },

  _wireNLH: function() {
    var $nlh = $();
    var $input = $();
    var $button = $();
    var $a = $();
    var $form = $();
    var $placeholder = $();
    var ref = this;

    const unbindDotcom = function(callback) {
      $nlh.removeClass("dotcom-bound");
      $button.off('click.dotcom');
      $input.off('focus.dotcom');
      $('body').off('click.dotcom');
      if (typeof callback == "function") {
        callback();
      }
    };

    const passClickToSubmit = function(e) {

      if ($("html").hasClass("spa-ua-mobile")) {
        return;
      }
      var $clicked = $(e.target);
      if ($clicked.hasClass("icon-search")) {
        e.preventDefault();
        e.stopPropagation();
        $clicked.parents('form').find('.submit').click();
      }
    };

    const submitNLH = function(e) {
      if (typeof e === "object") {
        e.preventDefault();
      }

      var $form = $(this),
        term = $form.find("input[type=text]").val(),
        url = $form.attr("action"),
        query = (typeof term === "string") ? escape(term) : "",
        lang = (typeof $boaLangObj === "object") ? $boaLangObj.boaLang.substr(0, 2) : "en",
        qs = "#?state={\"query\"%3A\"" + query + "\"%2C\"lang\"%3A\"" + lang + "\"}&id=1";

      location.href = url + qs;
      return false;
    };

    const loadNLHEmpty = function(e) {

      e.preventDefault();
      e.stopPropagation();

      var triggerSuggestions = function() {
          $('form', $nlh).submit();
        },
        checkReady = function() {
          var checkCount = 0,
            checkSearch = function() {
              checkCount++;
              if ((typeof boa === "object" &&
                  typeof boa.search === "object" &&
                  boa.search.isNavSearchInitialized) || checkCount > 50) {
                clearInterval(checkInterval);
                triggerSuggestions();
              }
            },
            checkInterval = setInterval(checkSearch, 250);
        };

      unbindDotcom(checkReady);
      loadNLH();
    };

    const loadNLH = function(e) {
      if (typeof e === "object") {
        e.preventDefault();
      }



      var $form = $input.parents('form'),
        assetEnv = spaParams.siteParams.secureHost,
        CSS = $form.data('css'),
        JS = $form.data('js'),
        completedAction = function() {
          ref.settings.$toggle.click();
          $input.focus();
        },
        completed = function() {
          $form.off('submit.dotcom');
          if ($nlh.hasClass("dotcom-bound")) {
            unbindDotcom(function() {
              setTimeout(completedAction, 600);
            });
          } else {
            completedAction();
          }
        },
        failed = unbindDotcom,
        link = document.createElement('link');

      JS = assetEnv + JS;
      CSS = assetEnv + CSS;

      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = CSS;
      document.getElementsByTagName("head")[0].appendChild(link);



      $.ajax({
        url: JS,
        cache: true,
        dataType: "script",
        success: completed,
        error: failed
      });

    };
    const hideNavigation = function(e) {
      $(".spa-page-navigation").removeClass("expanded");
      ref.settings.$menu.addClass("closed");
    };

    const hideSearch = function() {
      ref.settings.$toggle.filter(".search-visible").click();
    };

    const setupSearchPieces = function(container) {
      ref.settings.$target = $(container);
      $nlh = ref.settings.$target;
      $input = $('input[type="text"]', $nlh);
      $button = $('input[type="submit"]', $nlh);
      $a = $('a.icon', $nlh);
      $form = $input.parents("form");
      $placeholder = $();
    };
    setupSearchPieces(this.settings.target);


    if (window.cfLoader) {
      window.cfLoader.init(["cnx-regular"]);
    }




    $.spaChangeContent = function(options) {

      var defaults = {
        content: "",
        criterion: "",
        action: "",
        $nodes: $()
      };
      var data = {};
      var viewports = {
        "small": ["small"],
        "medium": ["medium"],
        "large": ["large", "largeCentered"],
        "not-small": ["medium", "large", "largeCentered", "xlarge", "xxlarge"],
        "not-large": ["small", "medium"],
        "all": ["small", "medium", "large", "largeCentered", "xlarge", "xxlarge"]
      };
      var changeRwdContent = function(data) {

        var $content = data.$nodes.filter("[data-rwd-content-current='true']").children().clone(true),
          viewport = spartaStoreUtility.getData('currentMQ.viewport');

        ref._adjustForParams();
        switch (data.action) {
          case "move":



            data.$nodes
              .empty().removeAttr("data-rwd-content-current")
              .each(function(i) {
                var $node = $(this),
                  criterion = $node.attr("data-rwd-content-rule");
                if ($.inArray(viewport, viewports[criterion]) > -1) {
                  $node.append($content).attr("data-rwd-content-current", "true");
                  setupSearchPieces(ref.settings.target);
                }
              });
            break;
        }
      };

      data = $.extend(true, {}, defaults, options);
      data.$nodes = $("[data-rwd-content='" + data.content + "']");

      switch (options.criterion) {
        case "breakpoint":
          changeRwdContent(data);
          spartaEventsUtility.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, () => {
            changeRwdContent(data)
          });
          break;
      }
      return this;
    };

    $.spaChangeContent({
      criterion: "breakpoint",
      content: "search",
      action: "move"
    });

    $('body').on('click.dotcom', passClickToSubmit);
    $form.on('submit.dotcom', submitNLH);
    $button.on("click.dotcom", loadNLHEmpty);
    $input.attr("value", "").on('focus.dotcom', loadNLH);
    ref.settings.$toggle.one("click", loadNLH)
      .click(hideNavigation);
    ref.settings.$menu.click(hideSearch);
    $nlh.addClass("ready dotcom-bound");
  },



  _injectIcons: function($container) {
    var $icons = $("[data-icon]", $container).add($container.filter("[data-icon]"));

    $icons.each(function() {
      var $object = $(this),
        iconName = $object.data("icon"),
        iconClass = $.map(iconName.split(" "), function(a) {
          return "icon-" + a;
        }).join(" "),
        $icon = $("<div class=\"icon\"/>").addClass(iconClass),
        iconParts = 4;

      if (iconName === "#!") {
        return;
      }

      for (var i = 1; i <= iconParts; i++) {
        $icon.append("<div class=\"icon-layer icon-layer--level" + i + "\"/>");
      }

      $object.removeData("icon").attr("data-icon", "#!");
      $object.append($icon);
    });
  },

  _adjustForParams: function() {
    const nav = $('.default-nav-links')[0];
    const navLabel = $('.nav-label')[0];

    $('.default-nav-links').addClass('account-for-params');

    navLabel
      ?
      $('.spa-nav-section-title').removeClass('account-for-params') :
      $('.spa-nav-section-title').addClass('account-for-params');

    nav
      ?
      $('.custom-nav-links').removeClass('account-for-params') :
      $('.custom-nav-links').addClass('account-for-params');
  },

  init: function(options) {
    var data;



    if (!window.jQuery) {
      window.jQuery = $;
    }

    this.settings = $.extend({}, this.defaults, options, this.required);
    this.settings.$target = $(this.settings.target);
    this.settings.$toggle = $(this.settings.toggle);
    this.settings.$menu = $(this.settings.menu);




    for (data in this.settings.data) {
      if (this.settings.$target.data(data)) {
        this.settings.data[data] = this.settings.$target.data(data);
      }
    }
    if (!this.checkConfig()) {
      return;
    }

    this._injectIcons(this.settings.$target.add(this.settings.$toggle));
    this._wireNLH();
  }

};
